export default __webpack_public_path__ + "static/media/no-data-cute.2d5b6e49.svg";